<template>
  <v-card class="mb-3">
    <v-card-title>
      {{label}}
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('up')">
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
      <v-btn icon @click="$emit('down')">
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <slot name="view" v-bind:block="block" v-bind:step="step"></slot>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn fab dark x-small color="blue" @click="editField()">
        <v-icon small>mdi-pencil</v-icon>
        <v-dialog v-model="edit" persistent max-width="980px">
          <v-card>
            <v-toolbar>
              <v-toolbar-title>Modification du champ</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation v-if="field">
                <slot
                  name="form"
                  v-bind:field="field"
                  :currentService="currentService"
                  :apiFields="apiFields"
                ></slot>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn text @click="cancel()">Annuler</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="save()">Sauver</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-btn>
      <v-btn fab dark x-small color="red" @click="deleteField()">
        <v-icon small>mdi-delete</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "FieldWrapper",
  props: {
    block: {
      type: Object,
      required: true
    },
    step: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  data: () => ({
    edit: false,
    valid: false,
    field: null,
    apiFields: []
  }),

  computed: {
    ...mapState("services", {
      api: state => state.api,
      currentService: state => state.currentService
    })
  },
  mounted: function() {
    this.getAvailableApiFields();
  },

  methods: {
    cancel() {
      this.field = null;
      this.edit = false;
    },
    editField() {
      this.field = Object.assign({}, this.block.fieldObject);
      this.edit = true;
    },
    save() {
      this.$emit("update", this.field);
      this.edit = false;
    },
    deleteField() {
      confirm("Etes-vous sûre d'effacer ce champ ?") && this.$emit("delete");
    },
    getAvailableApiFields() {
      if (this.currentService.api) {
        this.$store
          .dispatch("services/getAvailableApiFields", {
            step: this.step,
            block: this.block
          })
          .then(data => {
            this.apiFields = data;
          });
      }
    }
  }
};
</script>
